import '.s{position:fixed;}.ssr-plugin'
import '.cq{top:0px;}.ssr-plugin'
import '.bf{left:0px;}.ssr-plugin'
import '.bg{right:0px;}.ssr-plugin'
import '.eh{bottom:0px;}.ssr-plugin'
import '.gr{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gs{z-index:998;}.ssr-plugin'
import '.gt{transition:opacity 0.3s ease;}.ssr-plugin'
import '.w{height:100vh;}.ssr-plugin'
import '.y{width:100%;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.gu{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gv{z-index:999;}.ssr-plugin'
import '.h{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.z{justify-content:space-between;}.ssr-plugin'
import '.bl{padding:1.5rem;}.ssr-plugin'
import '.gw{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bz{flex-shrink:0;}.ssr-plugin'
import '.c1{flex:1;}.ssr-plugin'
import '.aq{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="s cq bf bg eh gr gs gt"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="s cq w y ac gu gv h i"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="h j z bl gw bz"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c1 aq bl"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
